import createCrud from './crud';
import { http, queryString } from 'utils'
import { map, omit, concat } from 'lodash'

// User mutation imports.
import { SET_LIST, SET_PAGINATION_DATA } from 'vx/mutations'

export default createCrud({
    resource: 'contacts',
    actions: {
        getClientContacts({ commit, state }, { id, payload }) {
            
            commit(SET_LIST, [])
            commit(SET_PAGINATION_DATA, null)
        
            return http.get(`clients/${id}/contacts?${queryString(payload)}`).then((response) => {
                if (response.data.hasOwnProperty('data')) {
                    commit(SET_LIST, response.data.data)
                } else {
                    commit(SET_LIST, response.data)
                }
                
                if (response.data.hasOwnProperty('meta')) {
                    commit(SET_PAGINATION_DATA, response.data.meta)
                } else {
                    commit(SET_PAGINATION_DATA, omit(response.data, 'data'))
                }
            }).catch(function (error) {
                if (error.response && error.response.status) {
                    notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                }
            })
        },
    }
});